var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSustainability(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.08 28.68C14.1 23.66 16.38 17.92 25 16C25 16 15 16 11.76 25.26C11.76 25.26 10 23.5 10 21.5C10 19.5 12 15.26 17 14.26C18.42 14 20 13.74 21.56 13.52C25.5 13 29.28 12.44 30 11C30 11 27 28 16 28C15.64 28 15.14 27.88 14.66 27.7L13.72 30L11.82 29.34L12.08 28.68ZM20 4C28.82 4 36 11.18 36 20C36 28.82 28.82 36 20 36C11.18 36 4 28.82 4 20C4 11.18 11.18 4 20 4ZM20 0C9 0 0 9 0 20C0 31 9 40 20 40C31 40 40 31 40 20C40 9 31 0 20 0Z",
    fill: "#85B6FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSustainability);
export default __webpack_public_path__ + "static/media/Sustainability.fe54479a28e9f5c739ee7dc43fc4ff1e.svg";
export { ForwardRef as ReactComponent };